import { memo } from 'react';
import { ModalOverlay as RACModalOverlay, ModalOverlayProps as RACModalOverlayProps } from 'react-aria-components';

import { merge } from '@/components';

export type ModalOverlayProps = RACModalOverlayProps & {};

const IModalOverlay = ({ className, children, ...rest }: ModalOverlayProps) => {
  return (
    <RACModalOverlay
      className={({ isEntering, isExiting }) => {
        return merge(
          'fixed inset-0 z-20 flex min-h-full items-center justify-center overflow-y-auto bg-gray-200/75 backdrop-blur-xs',
          isEntering && 'animate-in fade-in duration-300 ease-out',
          isExiting && 'animate-out fade-out duration-200 ease-in',
          className
        );
      }}
      isDismissable
      {...rest}
    >
      {children}
    </RACModalOverlay>
  );
};

export const ModalOverlay = memo(IModalOverlay) as typeof IModalOverlay;
